<template>
  <qc-container title="调查问卷">
    <page-request ref="table" url="/api/mgr/business/content/question/answer/list" :prop="{status:1}" :table-header="tableHeader" :expend="expend" :op-width="200">
      <template #op="scope">
        <b-button @click="toDetail(scope.row)">查看</b-button>
      </template>
    </page-request>
  </qc-container>
</template>

<script>
import QcContainer from "/src/components/el/layout/qc-container.vue";
import BButton from "@/components/el/b-button.vue";
import PageRequest from "@/components/base/page-request.vue";
import TButton from "@/components/el/t-button.vue";

export default {
  name: "questionnaire",
  components: {TButton, PageRequest, BButton, QcContainer},
  data() {
    return {
      tableHeader: [
        {prop: "code", label: "编号",width:160},
        {type:"user",label:"用户",width:220},
        {prop: "otherContent", label: "其他意见",minWidth:160},
        {prop: "createTime", label: "完成时间",width:160},
      ],
      expend:[
        {prop: "nickname", label: "用户名称"},
        {prop: "phone", label: "用户手机"},
        {prop: "userCode", label: "用户编号"},
        {label: "完成时间", start: "createTimeStart", end: "createTimeEnd", type: "daterange"},
      ],
    }
  },
  mixins: [tableBase],
  methods: {
    toDetail(row){
      this.toRouter("/index/lease/questionnaire/detail",{id:row.id});
    }
  },
  mounted() {

  }
}
</script>


<style lang="less" scoped>
</style>
